import React, { useState } from 'react';
import generateBarbellGraphic from './generateBarbellGraphic';
import SvgComponent from './svg';
import PlateSelector from './PlateSelector';
const BarbellCalculator = () => {
    const [showPlates, setShowPlates] = useState(false);
    const [isMetric, setIsMetric] = useState(false);
    const [plates, setPlates] = useState({
        45: 10,
        35: 10,
        25: 10,
        10: 10,
        5: 10,
        2.5: 10,
    });
    const [desiredWeight, setDesiredWeight] = useState(isMetric ? 60 : 135);
    const [barWeight, setBarWeight] = useState(isMetric ? 20 : 45);
    const [barbellGraphic, setBarbellGraphic] = useState(null);
    const [plateCounts, setPlateCounts] = useState(null);

    const handlePlateChange = (e) => {
        const { name, value } = e.target;
        setPlates({ ...plates, [name]: Number(value) });
      };

    const handleDesiredWeightChange = (e) => {
        setDesiredWeight(e.target.value);
    };

    const handleBarWeightChange = (e) => {
        setBarWeight(e.target.value);
    };

    const handleUnitChange = (e) => {
        const isMetric = e.target.checked;
        setIsMetric(isMetric);
        if (isMetric) {
        setPlates({
            20: 10,
            15: 10,
            10: 10,
            5:  10,
            2.5: 10,
            1.25: 10,
        });
    } else {
        setPlates({
            45: 10,
            35: 10,
            25: 10,
            10: 10,
            5: 10,
            2.5: 10,
        });
    }
        setDesiredWeight(isMetric ? 60 : 135);
        setBarWeight(isMetric ? 20 : 45);
    };

    const handleCalculate = () => {
        setBarbellGraphic(generateBarbellGraphic(desiredWeight, barWeight, plates, isMetric));
    };
    return (
        <div className='barbell-rack-calc'>
        <div className="container">
        <div className="input-container">
  <label>
    <input
      type="checkbox"
      checked={isMetric}
      onChange={handleUnitChange}
    />
    Use metric (kg)
  </label>
            <div>
                <label htmlFor="desired-weight">Desired Weight:</label>
                <input
                    type="range"
                    min={isMetric ? "20" : "45"}
                    max={isMetric ? "500" : "1000"}
                    step={isMetric ? "1" : "5"}
                    value={desiredWeight}
                    onChange={handleDesiredWeightChange}
                />
                <input
                    type="number"
                    min={isMetric ? "20" : "45"}
                    max={isMetric ? "500" : "1000"}
                    step={isMetric ? "1" : "5"}
                    value={desiredWeight}
                    onChange={handleDesiredWeightChange}
                />{' '}
                {isMetric ? 'kg' : 'lbs'}
            </div>
            <div>
                <label htmlFor="bar-weight">Bar Weight:</label>
                <input
                    type="number"
                    min={isMetric ? "2.5" : "15"}
                    max={isMetric ? "30" : "100"}
                    step={isMetric ? "0.5" : "5"}
                    value={barWeight}
                    onChange={handleBarWeightChange}
                />{' '}
                {isMetric ? 'kg' : 'lbs'}
                
                <button onClick={() => setShowPlates(!showPlates)}>
                    {showPlates ? 'Hide' : 'Set'} Plates Available
                </button>
                {showPlates && (
                    <>
                        <PlateSelector plates={plates} isMetric={isMetric} handlePlateChange={handlePlateChange} />
                    </>
                )}
            </div>
            <div>
                <button  onClick={handleCalculate}>Calculate</button>
            </div>
            </div>
            <div className="svg-container">
            {barbellGraphic && (
                <div>
                    <SvgComponent svg={barbellGraphic} />
                </div>
            )}
        </div>
        </div>
        </div>
    );
};

export default BarbellCalculator;